import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  static targets = [
    "container",
    "progressBar",
    "errorExplanation",
    "flashError",
    "flashNotice",
  ];
  static values = { timeout: Number };

  connect() {
    this.timeout = this.hasTimeoutValue ? this.timeoutValue : 3500;

    console.log("this.timeout ===>", this.timeout);
    if (
      this.hasErrorExplanationTarget ||
      this.hasFlashErrorTarget ||
      this.hasFlashNoticeTarget || this.hasContainerTarget
    ) {
      this.startAutoDismiss();
      this.startProgressBar();
    }
  }

  startAutoDismiss() {
    this.autoDismissTimeout = setTimeout(() => {
      this.dismiss();
    }, this.timeout);
  }

  stopAutoDismiss() {
    clearTimeout(this.autoDismissTimeout);
    this.stopProgressBar();
  }

  dismiss() {
    clearTimeout(this.autoDismissTimeout);

    if (this.hasContainerTarget) {
      this.containerTarget.style.transition = "opacity 0.35s ease-out";
      this.containerTarget.style.opacity = "0";
      setTimeout(() => {
        this.containerTarget.remove();
      }, 500);
    }
  }

  mouseenter() {
    if (
      this.hasErrorExplanationTarget ||
      this.hasFlashErrorTarget ||
      this.hasFlashNoticeTarget
    ) {
      this.stopAutoDismiss();
    }
  }

  mouseleave() {
    if (
      this.hasErrorExplanationTarget ||
      this.hasFlashErrorTarget ||
      this.hasFlashNoticeTarget
    ) {
      this.startAutoDismiss();
    }
  }

  startProgressBar() {
    if (this.hasProgressBarTarget) {
        this.progressBarTarget.style.setProperty(
        "--flash-timeout",
        `${this.timeout}ms`
      );
      this.progressBarTarget.style.transition = `width ${this.timeout}ms linear`;
      this.progressBarTarget.style.width = "100%";
    }
  }

  stopProgressBar() {
    if (this.hasProgressBarTarget) {
      const computedStyle = window.getComputedStyle(this.progressBarTarget);
      const currentWidth = computedStyle.width;
      this.progressBarTarget.style.transition = "none";
      this.progressBarTarget.style.width = currentWidth;
    }
  }

  dismissManually(event) {
    event.preventDefault();
    this.dismiss();
  }
}
